<template>
  <div id="orderList">
    <crumbs title="订购套件管理" />
    <el-row class="query-bar">
      <el-col class="flush-right" :span="24">
        <el-switch
          v-model="queryCondition.OrderSequence"
          :active-value="0"
          active-text="按时间降序"
          :inactive-value="1"
          inactive-text="按时间升序"
        >
        </el-switch>
      </el-col>
    </el-row>
    <div
      class="query-table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <div>
        <el-table
          :data="queryList"
          border
          stripe
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column
            prop="Name"
            label="姓名"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="phone"
            label="电话"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="Email"
            label="邮箱"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="PuchaseCount"
            label="购买数量"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="CompanyName"
            label="单位名称"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="CreateTime"
            label="创建时间"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
      <div class="flush-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.PageSize"
          :current-page.sync="queryCondition.PageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Crumbs from "./component/crumbs";
export default {
  name: "orderList",
  created() {
    this.loadList();
  },
  data() {
    return {
      total: 0,
      //查询条件
      queryCondition: {
        OrderSequence: 0,
        PageIndex: 1,
        PageSize: 15
      },
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: []
    };
  },
  methods: {
    //获取列表
    loadList() {
      //初始化
      this.queryList = [];
      this.isLoading = true;
      this.requestApi(
        "order",
        "getOrderList",
        { ...this.queryCondition },
        res => {
          this.isLoading = false;
          this.total = res.Count;
          this.queryList = res.OrderLinkList;
        }
      );
    },
    //点击切换时间排序
    handleTimeSort() {
      this.queryCondition.PageIndex = 1;
      this.loadList();
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  },
  watch: {
    "queryCondition.OrderSequence": "handleTimeSort"
  },
  components: {
    Crumbs
  }
};
</script>

<style lang="less"></style>
